import specialTheme from '../../specialTheme';

const theme = specialTheme({});

export default theme;
